import * as ROUTES from '../routes';

const Navigations = [
    {
        title: "Settings",
        icon: "mdi-cog-outline",
        to: ROUTES.PROFILE,
        mini: false,
        permissions: [],
        subNav: [
            {
                title: "Profile",
                to: ROUTES.PROFILE,
                icon: 'mdi-account'
            },
            {
                title: "Change Password",
                to: ROUTES.CHANGEPASSWORD,
                icon: 'mdi-lock'
            },
            {
                title: "Change Pin",
                to: ROUTES.CHANGEPIN,
                icon: 'mdi-lock'
            },
        ]
    },
]

export default Navigations